"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.operators = exports.numberIfNumberlike = void 0;
exports.createGenericRule = createGenericRule;
const numberIfNumberlike = (source) => {
    const asNumber = typeof source === 'string' ? Number(source) : NaN;
    if (isNaN(asNumber))
        return source;
    return asNumber;
};
exports.numberIfNumberlike = numberIfNumberlike;
exports.operators = {
    equal: (a, b) => a === b,
    equals: (a, b) => a === b,
    notEqual: (a, b) => a !== b && a,
    notEquals: (a, b) => a !== b,
    lessThan: (a, b) => a < b,
    greaterThan: (a, b) => a > b,
    greaterThanOrEqual: (a, b) => a >= b,
    lessThanOrEqual: (a, b) => a <= b,
    olderThanYears: (a, years) => {
        const now = new Date();
        const then = new Date();
        then.setFullYear(Number(a));
        const diff = 1000 * 60 * 60 * 24 * 365 * years;
        return (now.valueOf() - then.valueOf() > diff && a != '' && a != null);
    },
};
// exaple: rule::Q_Is_the_insured_the_owner_of_vessel::equal::Yes
function createGenericRule(raw) {
    if (!raw.startsWith('rule::')) {
        throw new Error('This is not a generic rule' + raw);
    }
    const expression = raw.slice(6);
    const [affectingQuestionId, operator, comparable] = expression.split('::');
    const isComparableUndefined = typeof comparable === 'undefined';
    if (!affectingQuestionId || !operator || isComparableUndefined) {
        throw new Error(`Could not compile expression ${expression}`);
    }
    const op = exports.operators[operator];
    if (!op) {
        throw new Error(`Invalid operator ${operator}`);
    }
    // try to convert to number value
    return {
        affectingQuestionId,
        op,
        comparable: (0, exports.numberIfNumberlike)(comparable),
    };
}
